import { colors } from '@/common/helpers';
import { ReactElement } from 'react';
import { Text } from 'recharts';
import { LABEL_X_COLOR_DEFAULT, TickY } from '../BarChart.types';

export const renderTickX = (props: any): ReactElement => {
  const { x, y, payload, tickX } = props;
  const tickValue = payload.value;

  // This is to display data by week with like break just after the week number.
  const multipleLinesTick: string[] = [];

  if (tickX?.transformLabelFn) {
    const tickXTitles = tickX.transformLabelFn(tickValue);
    tickXTitles.forEach((title: string) => multipleLinesTick.push(title));
    // TODO: Verify which chart uses this transformation and add it as a
    // transformLabelFn instead of having this logic in here
  } else if (tickValue?.includes?.('Week')) {
    multipleLinesTick.push(tickValue.slice(0, 4), tickValue.slice(7));
  }

  if (multipleLinesTick.length > 0) {
    let dy = y;
    return (
      <>
        {multipleLinesTick.map((item, index) => {
          if (index > 0) dy += 17;

          const addedStyles = tickX?.transformLabelCssFn ? tickX.transformLabelCssFn(index) : {};

          return (
            <Text
              fill={colors?.labelX ?? LABEL_X_COLOR_DEFAULT}
              fontSize={12}
              fontWeight={500}
              key={index}
              lineHeight={16}
              textAnchor="middle"
              verticalAnchor="start"
              width={120}
              y={dy}
              x={x}
              style={addedStyles}
            >
              {item}
            </Text>
          );
        })}
      </>
    );
  }

  return (
    <Text
      fill={colors?.labelX ?? LABEL_X_COLOR_DEFAULT}
      fontSize={12}
      fontWeight={500}
      lineHeight={16}
      textAnchor="middle"
      verticalAnchor="start"
      width={120}
      y={y}
      x={x}
    >
      {tickValue}
    </Text>
  );
};

export const formatTickY = (value: string, tickY?: TickY): string => {
  const number = parseInt(value);
  const parse = tickY?.scale ? tickY?.scale : 1;

  if (tickY?.unit?.onlyOnMin) {
    return tickY.min === number
      ? `${(number / parse).toString()}${tickY?.unit.symbol ?? ''}`
      : `${(number / parse).toString()}`;
  }

  if (tickY?.unit?.onlyOnMax) {
    return tickY.max === number
      ? `${(number / parse).toString()}${tickY?.unit.symbol ?? ''}`
      : `${(number / parse).toString()}`;
  }

  return number === 0 ? `${(number / parse).toString()}` : `${(number / parse).toString()}${tickY?.unit.symbol ?? ''}`;
};

export const getDomain = (maxYAxisDomain: number, tickY?: TickY): [string | number, string | number] => {
  const min = tickY?.min ?? 'auto';
  const max = tickY?.max ?? maxYAxisDomain ?? 'auto';

  return [min, max];
};
